import React from 'react';
import { motion } from 'framer-motion';
import { shareOnTwitter } from '../utils/shareUtils';
import './ShareButton.css';

/**
 * ShareButton Component
 * Reusable button for sharing to Twitter/X
 */
function ShareButton({ 
  tweetText, 
  variant = 'default', 
  size = 'medium',
  fullWidth = false,
  icon = '🐦',
  label = 'Share on 𝕏',
  className = '',
  disabled = false,
  onShareClick
}) {
  
  const handleClick = () => {
    if (disabled) return;
    
    // Call custom handler if provided
    if (onShareClick) {
      onShareClick();
    }
    
    // Open Twitter share
    if (tweetText) {
      shareOnTwitter(tweetText);
    }
  };

  return (
    <motion.button
      className={`share-button share-button-${variant} share-button-${size} ${fullWidth ? 'share-button-full' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      whileHover={{ scale: disabled ? 1 : 1.05 }}
      whileTap={{ scale: disabled ? 1 : 0.95 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <span className="share-icon">{icon}</span>
      <span className="share-label">{label}</span>
    </motion.button>
  );
}

export default ShareButton;
